import type { ReactNode } from "react";
import { cn } from "@/core/shared/v2/lib/utils";

export type CardProps = {
  children: ReactNode;
  className?: string;
  id?: string;
};

export const Card = ({ children, className, id }: CardProps) => {
  return (
    <div className={cn("rounded-2xl bg-card p-4 lg:p-6 lg:py-8", className)} id={id}>
      {children}
    </div>
  );
};
